import { type MessageId } from './en-US';

const pt_PT: { [K in MessageId]: string } = {
  'analyse.level1DistributionTitle': 'Melhores subestações para poda',
  'analyse.level1TransmissionTitle': 'Melhores distritos para poda',
  'analyse.level2DistributionTitle': 'Melhores circuitos para poda',
  'analyse.level2DistributionCircuitTitle': 'Melhores circuitos para podar',
  'analyse.level2TransmissionTitle': 'Melhores linhas para podar',
  'analyse.level2TransmissionSegmentTitle': 'Melhores segmentos para podar',
  'analyse.level2TransmissionTreesTitle': 'Circuitos por número de',
  'analyse.level2DistributionCircuitHazardTreesTitle':
    'Circuitos por número de árvores de risco',
  'analyse.level2DistributionCircuitTreesTitle': 'Circuitos por número de',
  'analyse.level2DistributionHazardTreesTitle': '', // Unused?
  'analyse.level2DistributionTreesTitle': '', // Unused?
  'analysis.wildfireEncroachmentRisk':
    'milhas de invasão fora da zona de risco',
  'analysis.filterButton': 'Filtros',
  'analysis.moreFiltersButton': 'Mas filtros',
  'export.fileTypeCSV': 'CSV',
  'export.fileTypeXLS': 'Excel (.xls)',
  'export.optionsTitle': 'Escolher formato',
  'export.fileErrorMessage': 'Something went wrong. Try again later',
  'export.fileTooLarge':
    'Está a tentar exportar demasiados registos. Utilize filtros para reduzir a sua seleção.',
  'export.downloadSuccessful': 'Ficheiro transferido com sucesso',
  'list.encroachmentAnalysisViewTitle': 'Analisar a sua rede por',
  'list.fallInAnalysisViewTitle': 'Analisar a sua rede por',
  'list.fallInHazardTreesCountLabel': 'Árvores de risco',
  'list.priorityAnalysisViewTitle': 'Classificar e ver rede por',
  'list.wildfirePriorityAnalysisViewTitle': 'Classificar e ver rede por',
  'list.clearAnalysisViewTitle': 'Classificar e ver rede por',
  'list.workloadAnalysisViewTitle': 'Classificar e ver rede por',
  'list.clearFilterButton': 'Limpar todos os filtros',
  'list.noResultsWithActiveFilters':
    'Nenhum resultado com os filtros ativos atuais.',
  'list.noResultsForSelectedAnalysis':
    'Não há dados disponíveis para a análise selecionada.',
  'list.totalSpans': '{num, plural, one {# intervalo} other {# intervalos}}',
  'list.level2DistributionCircuitTotalsLabel':
    '{num, plural, one {# circuito} other {# circuitos}}',
  'list.level2TransmissionTotalsLabel':
    '{num, plural, one {# linha} other {# linhas}}',
  'list.level2TransmissionSegmentTotalsLabel':
    '{num, plural, one {# segmento} other {# segmentos}}',
  'list.viewOnMapButton': 'Ver no mapa',
  'list.encroachmentAnalysisView': 'Risco de invasão',
  'list.encroachmentAnalysisViewDescription':
    'Identificar onde as árvores estão próximas da linha',
  'list.fallInHealthAnalysisView': 'Fall-in & health risk',
  'list.fallInHealthAnalysisViewDescription':
    'Identificar onde as árvores têm maior probabilidade de cair sobre a linha e onde estão as árvores em declínio',
  'list.priorityAnalysisView': 'Priority level',
  'list.reliabilityPriorityAnalysisView': 'Reliability priority level', // only for customers with wildfire priority analyses
  'list.priorityAnalysisViewDescription':
    'Identificar locais com alto risco de vegetação que são críticos para a sua rede',
  'list.wildfirePriorityAnalysisView': 'Wildfire priority level',
  'list.wildfirePriorityAnalysisViewDescription':
    '(TODO): Identify locations with high wildfire and vegetation risk',
  'list.clearAnalysisView': 'Sem risco',
  'list.clearAnalysisViewDescription':
    'Vãos sem árvores detetadas (ou distantes) na faixa de servidão e sem árvores com potencial de impacto próximas',
  'list.workloadAnalysisView': 'Inspector workload',
  'list.criticalTreesInventoryView': 'Critical trees inventory',
  'list.workloadAnalysisViewDescription':
    'Identify where trees are possibly encroaching onto the compliance zone and need inspection',
  'worklog.addActivity': 'Adicionar atividade',
  'worklog.editActivity': 'Editar atividade',
  'worklog.activityDeletingTitle': 'Excluir atividade',
  'worklog.activityDeletingMessage': 'Excluindo atividade...',
  'worklog.activityDeleteSuccess': 'Atividade excluída com sucesso',
  'worklog.activitySaveError': 'Não foi possível salvar a atividade',
  'worklog.activityDeleteError': 'Não foi possível excluir a atividade',
  'worklog.adding': 'Adicionando atividade...',
  'worklog.addingMessage': 'Estamos adicionando a atividade a este trecho.',
  'worklog.addSuccess': 'Atividade adicionada com sucesso',
  'worklog.addSuccessMessage': 'A atividade foi adicionada.',
  'worklog.updating': 'Atualizando atividade...',
  'worklog.updatingMessage':
    'Estamos atualizando a atividade para este trecho.',
  'worklog.updateSuccess': 'Atividade atualizada com sucesso',
  'worklog.updateSuccessMessage': 'A atividade foi atualizada.',
  'worklog.activityDeleteConfirmation':
    'Tem certeza de que deseja excluir esta entrada de campo?',
  'worklog.dateOfCompletion': 'Data de conclusão',
  'worklog.dateOfInspection': 'Data da inspeção',
  'worklog.datePlaceholder': 'Selecionar data e hora',
  'worklog.notesLabel': 'Notas (Opcional)',
  'worklog.notesPlaceholder': 'Digite as notas aqui...',
  'worklog.syncedFromSource': 'Sincronizado de {source} em {date}',
  'worklog.program': 'Programa: {name}',
  'list.rankBy': 'Rank by',
  'list.groupBy': 'Agrupar por',
  'list.groupByName': 'Por {name}',
  'list.chooseObjective': 'Escolher objetivo',
  'list.groupByLabel': 'Agrupar por',
  'list.learnMore': 'Saber mais',
  'list.fuelHazardScore': 'Pontuação de perigo de combustível',
  'list.aboutHowRiskIsAggregated': 'sobre como o risco é agregado',
  'level3.distribution': 'Distribuição',
  'level3.transmission': 'Transmissão',
  'level3.overgrowthIndexLabel': 'Índice de sobrecrescimento',
  'level3.healthIndexLabel': 'Índice de saúde',
  'level3.criticalRatingLabel': 'Crítico',
  'level3.highRatingLabel': 'Alto',
  'level3.mediumRatingLabel': 'Médio',
  'level3.lowRatingLabel': 'Baixo',
  'level3.minorRatingLabel': 'Menor',
  'level3.noneRatingLabel': 'Nenhum',
  'level3.unknownRatingLabel': 'Desconhecido',
  'level3.spanLengthField': '{length, plural, one {# milha} other {# milhas}}',
  'level3.spanLengthFieldMetric':
    '{length, plural, one {# quilômetro} other {# quilômetros}}',
  'level3.level1Distribution': 'Subestação',
  'level3.level1DistributionDivision': 'Divisão',
  'level3.level2DistributionCircuit': 'Circuito',
  'level3.level1Transmission': 'Distrito',
  'level3.level2Transmission': 'Linha',
  'level3.level2TransmissionSegment': 'Segmento',
  'level3.hazardTreesCount': 'Contagem de árvores de risco',
  'level3.decliningTreesCount': 'Contagem de árvores em declínio',
  'level3.strikeTreesCount': 'Contagem de árvores com potencial de impacto',
  'level3.criticalTreesCount': 'Contagem de árvores críticas',
  'search.placeholder': 'Pesquisar',
  'search.noResults': 'Nada encontrado com este termo.',
  'search.noResultsWithActiveFilters':
    'Nenhum resultado com os filtros ativos atuais.',
  'search.clearFilterButton': 'Limpar todos os filtros',
  'search.groupLabel.Spans': 'Trechos',
  'search.groupLabel.Poles': 'Postes',
  'search.groupLabel.Addresses': 'Endereços',
  'search.groupLabel.Coordinates': 'Coordenadas',
  'search.groupLabel.SpansInternal': '[Interno] ID Overstory',
  'filter.showResults': 'Mostrar resultados',
  'filter.keepTypingToNarrow':
    'Demasiadas correspondências para mostrar de uma só vez. Continue a escrever para restringir os resultados.',
  'filter.clear': 'Limpar',
  'filter.title': 'Filtro',
  'filter.spanCountTooltip': '{count} linhas correspondem ao filtro atual',
  'filter.totalSpansTooltip': 'Total de linhas no Overstory',
  'filter.of': 'de',
  'filter.analysisDateTitle': 'Data da análise',
  'filter.lastAnalyzedLabel': 'Última analisada',
  'filter.allYearsPlaceholder': 'Todos os anos',
  'filter.otherPlaceholder': 'Outro',
  'filter.activitySection': 'Atividade',
  'filter.networkSection': 'Rede',
  'filter.networkTypeSection': 'Rede',
  'filter.allNetworkOption': 'Todas',
  'filter.distributionOption': 'Distribuição',
  'filter.transmissionOption': 'Transmissão',
  'filter.distributionSection': 'Distribuição',
  'filter.transmissionSection': 'Transmissão',
  'filter.vegetationRiskSection': 'Risco de vegetação',
  'filter.riskAndVegetationSection': 'Risco e Vegetação',
  'filter.spanSection': 'Linha',
  'filter.workYearSingleYearQuickSelectLabel': 'apenas',
  'filter.level1DistributionLabel': 'Subestações',
  'filter.level1DistributionPlaceholder': 'Todas as subestações',
  'filter.level1DistributionDivisionLabel': 'Divisão',
  'filter.level1DistributionDivisionPlaceholder': 'Todas as divisão',
  'filter.level1TransmissionLabel': 'Distritos',
  'filter.level1TransmissionPlaceholder': 'Todos os distritos',
  'filter.level2DistributionLabel': 'Alimentadores',
  'filter.level2DistributionPlaceholder': 'Todas as alimentadores',
  'filter.level2DistributionCircuitLabel': 'Circuitos',
  'filter.level2DistributionCircuitPlaceholder': 'Todos os circuitos',
  'filter.level2TransmissionLabel': 'Linha',
  'filter.level2TransmissionPlaceholder': 'Todas as linhas',
  'filter.level2TransmissionSegmentLabel': 'Segmentos',
  'filter.level2TransmissionSegment': 'Segmento',
  'filter.level2TransmissionSegmentPlaceholder': 'Todos os segmentos',
  'filter.overgrowthIndexLabel': 'Índice de sobrecrescimento',
  'filter.encroachmentRiskLabel': 'Risco de invasão',
  'filter.encroachmentRiskPlaceholder': 'Todos os níveis',
  'filter.minEncroachmentRatingLabel': 'Min índice',
  'filter.maxEncroachmentRatingLabel': 'Max índice',
  'filter.phaseSystemLabel': 'Sistema de Fase',
  'filter.spanTypeLabel': 'Tipo de linha de operação',
  'filter.singlePhaseSpanTypeLabel': 'Monofásicos',
  'filter.twoPhaseSpanTypeLabel': 'Bifásico',
  'filter.threePhaseSpanTypeLabel': 'Trifásicos',
  'filter.treeSpeciesLabel': 'Contém espécies de árvores',
  'filter.treeSpeciesPlaceholder': 'Todas as espécies de árvores',
  'filter.voltageLabel': 'Voltagem',
  'filter.voltagePlaceholder': 'Todas as voltagens',

  'filter.hazardTreesTitle': 'Árvores de risco',
  'filter.hazardTreesLabel': 'Mostrar apenas vãos com árvores de risco',
  'filter.strikeTreesTitle': 'Árvores com potencial de impacto',
  'filter.strikeTreesLabel':
    'Mostrar apenas vãos com árvores com potencial de impacto',
  'filter.criticalTreesTitle': 'Árvores críticas',
  'filter.criticalTreesLabel': 'Mostrar apenas vãos com árvores críticas',
  'filter.encroachmentTypeLabel': 'Tipo de invasão',
  'filter.encroachmentTypePlaceholder': 'Todos os tipos de invasão',
  'filter.allEncroachmentTypesLabel': 'Todos os tipos de invasão',
  'filter.withOverhangLabel': 'Com saliência',
  'filter.withoutOverhangLabel': 'Sem saliência',

  'widget.summary.level2DistributionCircuitTotalsLabel':
    '{num, plural, one {# circuito} other {# circuitos}}',
  'widget.summary.level2TransmissionSegmentTotalsLabel':
    '{num, plural, one {# segmento} other {# segmentos}}',
  'widget.summary.level1DistributionSubstationTotalsLabel':
    '{num, plural, one {# subestação} other {# subestações}}',
  'widget.summary.level1TransmissionSegmentTotalsLabel':
    '{num, plural, one {# divisão} other {# divisões}}',
  'widget.summary.level1DistributionVMUTotalsLabel':
    '{num, plural, one {# VMU} other {# VMUs}}',
  'widget.trees.metricCount': 'Contar',
  'widget.trees.metricAvgPerMile': 'Média por milha',
  'widget.trees.metricAvgPerKilometer': 'Média por quilômetro',
  'widget.hazardTreeTitle': 'Reduzir interrupções por queda',
  'widget.treesTitle': 'Monitor fall-in risk',
  'widget.fallIn.hazardTreesTitle': 'Total de árvores de risco',
  'widget.fallIn.decliningTreesTitle': 'Total de árvores em declínio',
  'widget.fallIn.strikeTreesTitle': 'Total de árvores com potencial de impacto',
  'widget.fallIn.hazardTreesDropdownLabel': 'árvores de risco',
  'widget.fallIn.decliningTreesDropdownLabel': 'árvores em declínio',
  'widget.fallIn.strikeTreesDropdownLabel': 'árvores com potencial de impacto',
  'map.tooltip.horizontalDistanceToLine': 'Dist. H. à linha',
  'map.tooltip.verticalDistanceToLine': 'Dist. V. à linha',
  'map.tooltip.worktype': 'Tipo de trabalho',
  'map.geolocation.permissionError':
    'Overstory não tem permissão para usar sua localização.',
  'map.geolocation.otherError':
    'Não conseguimos obter sua localização atual. Por favor, tente novamente.',
  'map.modal.hazardTreeTitle': 'Árvore de risco',
  'map.layerManager.treesDescription': 'Selecione o tipo de árvores a incluir',
  'map.layerManager.hazardTreesTitle': 'Árvores de risco',
  'map.layerManager.decliningTreesTitle': 'Árvores em declínio',
  'map.layerManager.strikeTreesTitle': 'Árvores com potencial de impacto',
  'map.layerManager.worktypeAnalysisTitle': 'Tipo de trabalho',
  'map.layerManager.workStatusTitle': 'Estado do trabalho',
  'map.layerManager.fuelHazardTitle': 'Perigo de combustível',
  'map.layerManager.fuelHazardDescription':
    'Mostra a facilidade com que um incêndio se pode propagar com base nos tipos de combustível no terreno.',
  'map.layerManager.title': 'Camadas',
  'map.legend.hazardTreesTitle': 'Árvores de risco',
  'map.legend.decliningTreesTitle': 'Árvores em declínio',
  'map.legend.strikeTreesTitle': 'Árvores com potencial de impacto',
  'map.legend.learnMoreAbout': 'Saiba mais sobre',
  'map.legend.fallIn.title': 'Risco de queda e à saúde',
  'map.legend.fuelHazard.title': 'Perigo de combustível',
  'map.legend.fuelHazard.low': 'Baixo',
  'map.legend.fuelHazard.high': 'Alto',
  'map.legend.fuelHazard.scale': 'perigo de combustível',
  'map.legend.fallIn.help.link':
    'https://help.overstory.com/en/articles/10006672-fall-in-health-risk',
  'map.legend.fallIn.help.linkText': 'Queda e à saúde',
  'program.defaultName': 'Cronograma de Ciclos',
  'program.status.in_progress': 'Em andamento',
  'program.status.completed': 'Concluído',
  'program.status.todo': 'A fazer',
  'program.status.to_audit': 'Para auditar',
  'spanMapPopover.more': 'Mais',
  'spanMapPopover.addActivity': 'Adicionar atividade',
  'customList.project': 'Projeto',
  'customList.addToList': 'Adicionar ao projeto',
  'customList.seeAll': 'Ver todos',
  'projectDemo.projectsPlaceholder': 'Crie um projeto para começar.',
  'projectDemo.setProjectScope': 'Definir âmbito do projeto',
  'projectDemo.scopeHint':
    'Adicione regras para definir quais os troços a incluir no âmbito',
  'projectDemo.addCondition': 'Adicionar condição',
  'projectDemo.expectedOutcomes': 'Resultados esperados',
  'projectDemo.expectedVegetationSaidi': 'SAIDI de vegetação esperado',
  'projectDemo.progress': 'Progresso',
  'projectDemo.completed': 'Concluído:',
  'projectDemo.remaining': 'Por fazer:',
  'projectDemo.riskBuyDown': 'Redução do risco de invasão',
  'projectDemo.progressTooltip':
    '{completed, plural, one {# troço concluído} other {# troços concluídos}}, {remaining, plural, one {# por fazer} other {# por fazer}}',
  'projectDemo.noSpansAtRating': 'Sem troços com esta classificação no âmbito',
  'projectDemo.noSpans': 'Sem troços no âmbito.',
  'projectDemo.confirmHintName': 'Introduza um nome de projeto para continuar',
  'projectDemo.confirmHintScope':
    'Adicione pelo menos uma condição para continuar',
  'projectDemo.confirmHintIncomplete':
    'Complete todas as condições para continuar',
  'projectDemo.confirmHintLoading': 'A verificar o âmbito…',
  'projectDemo.confirmHintNoSpans':
    'Alargue o âmbito para incluir pelo menos um troço',
  'projectDemo.sync': 'Sincronizar',
  'projectDemo.syncPreparing': 'A preparar registos de trabalho…',
  'projectDemo.syncPushing': 'A enviar registos de trabalho para o Fulcrum…',
  'projectDemo.syncPulling': 'A obter atualizações do Fulcrum…',
  'projectDemo.syncSaving': 'A guardar alterações…',
  'projectDemo.syncOtherProject':
    'Outro projeto está a sincronizar com o Fulcrum…',
  'projectDemo.syncStatusUnavailable':
    'Não foi possível verificar o progresso da sincronização. A restabelecer a ligação…',
  'projectDemo.syncError':
    'Não foi possível sincronizar com o Fulcrum. Tente novamente.',
  'projectDemo.lastSynced':
    'Última sincronização com o Fulcrum:\n{date} às {time}',
  'projectDemo.projectNotFound': 'Este projeto não foi encontrado.',
  'projectDemo.projectsLoadError': 'Não foi possível carregar os projetos.',
  'projectDemo.resetTitle': 'Repor o estado da demonstração',
  'projectDemo.resetDescription':
    'Remove o estado de demonstração de {client}: os seus registos de trabalho, os seus projetos e todos os registos e projetos do seu formulário Fulcrum.',
  'projectDemo.resetWarning':
    'Esta ação não pode ser anulada. Os registos e projetos serão removidos da aplicação Fulcrum Vegetation Management.',
  'projectDemo.resetPickClient': 'Escolha um cliente para repor.',
  'projectDemo.resetButton': 'Repor o estado da demonstração',
  'projectDemo.resetConfirmTitle': 'Repor o estado da demonstração?',
  'projectDemo.resetConfirmBody':
    'Isto remove todos os registos de trabalho e projetos de {client} e esvazia o seu formulário Fulcrum. Não pode ser anulado.',
  'projectDemo.resetConfirm': 'Repor',
  'projectDemo.resetCancel': 'Manter os dados',
  'projectDemo.resetResultTitle': 'O que a reposição removeu',
  'projectDemo.resetWorkLogs': 'Registos de trabalho',
  'projectDemo.resetPlans': 'Projetos',
  'projectDemo.resetRecords': 'Registos do Fulcrum',
  'projectDemo.resetProjects': 'Projetos do Fulcrum',
  'projectDemo.resetDone': 'O estado da demonstração está limpo.',
  'projectDemo.resetPartial':
    'Parte da reposição não foi concluída. Leia o detalhe abaixo e tente novamente ou peça ajuda.',
  'projectDemo.resetFailed':
    'A reposição não foi executada. Tente novamente ou peça ajuda com esta mensagem: {detail}',
  'customList.allLists': 'Todos os projetos',
  'customList.lists': 'Projetos',
  'customList.newList': 'Novo projeto',
  'customList.noListsAvailable': 'Nenhum projeto disponível.',
  'customList.createList': 'Criar projeto',
  'customList.creatingList': 'Criando projeto...',
  'customList.createListSuccess': 'Projeto criado com sucesso!',
  'customList.creatingListMessage':
    'Estamos criando seu novo projeto. Por favor, aguarde.',
  'customList.addingToList': 'Adicionando ao projeto...',
  'customList.addingToListMessage':
    'Estamos adicionando os trechos selecionados ao projeto.',
  'customList.addedSpansToListTitle': 'Adicionado ao projeto com sucesso.',
  'customList.spansAddedToListDescription':
    '{count, number} trechos adicionados ao projeto <a>{listName}</a>',
  'customList.newListDescription': 'Novo projeto',
  'customList.addToNewList': 'Adicionar a novo projeto',
  'customList.name': 'Nome do projeto',
  'customList.namePlaceholder': 'Nome do projeto',
  'customList.nameRequired': 'Nome do projeto é obrigatório',
  'customList.description': 'Descrição do projeto (opcional)',
  'customList.descriptionPlaceholder': 'Descrição',
  'customList.errorAddingToList': 'Erro ao adicionar ao projeto',
  'customList.listDetails': 'Detalhes do projeto',
  'customList.deleteList': 'Excluir projeto',
  'customList.removeFrom': 'Remover de',
  'customList.removeFromListError':
    'Erro ao remover do projeto. Por favor, tente novamente.',
  'customList.deleteError': 'Erro ao excluir projeto',
  'customList.removeSpanError': 'Erro ao remover trecho do projeto',
  'customList.deleteConfirmationMessage':
    'Tem certeza de que deseja excluir permanentemente este projeto para todos?',
  'customList.getStarted':
    'Adicione trechos aos projetos para facilmente acompanhar, compartilhar e retornar mais tarde.',
  'customList.deleteErrorMessage': 'Houve um erro ao excluir o projeto.',
  'customList.notFound': 'Projeto não encontrado.',
  'customList.noListItems': 'Nenhum trecho neste projeto.',
  'customList.scopeHeader': 'Qual é o escopo?',
  'customList.addSpans': 'Adicionar intervalos',
  'customList.addSpansDescription':
    'Adicione intervalos a este projeto para rastrear, compartilhar e retornar mais tarde com facilidade.',
  'customList.editList': 'Editar projeto',
  'customList.editError': 'Erro ao editar projeto',
  'customList.editErrorMessage': 'Houve um erro ao editar o projeto.',
  'customList.loadError':
    'Erro ao carregar projeto. Entre em contato com seu gerente de sucesso do cliente Overstory.',
  'customList.copyLinkMessage': 'Enviar um link para este projeto',
  'customList.addToListDisabled':
    'Aplique filtros para focar em um conjunto específico de trechos.',
  'customList.addALotToListAreYouSure':
    'Tem certeza de que deseja adicionar {count, number} trechos a um projeto?',
  'customList.addALotToListMessage':
    'Considere aplicar mais filtros para focar em um conjunto mais acionável de trechos.',
  'customList.addALotToListConfirm': 'Adicionar todos os trechos ao projeto',
  'customList.addALotToListCancel': 'Refinar seleção',
  'customList.steps': 'Passo {onStep} de {ofStep} - {action}',
  'customList.stepActionFilterToAdd':
    'Filtre os trechos que gostaria de adicionar a este projeto',
  'customList.addToProject': 'Adicionar ao projeto',
  'customList.filterDisabledNoSpans':
    'Adicione intervalos a este projeto para habilitar a filtragem',
  'customList.uploadCsv': 'Carregar CSV',
  'customList.errorLoadingLists': 'Erro ao carregar listas personalizadas',
  'customList.createProjectFromCsv': 'Criar Projeto a partir de CSV',
  'customList.csvFileRequired': 'Arquivo CSV é obrigatório',
  'customList.level2HeaderRequired': 'Cabeçalho do Nível 2 é obrigatório',
  'customList.level3HeaderRequired': 'Cabeçalho do Nível 3 é obrigatório',
  'customList.csvFileLabel': 'Arquivo CSV',
  'customList.selectCsvFile': 'Selecionar arquivo CSV',
  'customList.csvUploadDescription':
    'Carregue um arquivo CSV contendo dados de trechos com colunas level2 e level3.',
  'customList.level2ColumnName': 'Nome da Coluna do Nível 2',
  'customList.level2Placeholder': 'nível2',
  'customList.level3ColumnName': 'Nome da Coluna do Nível 3',
  'customList.level3Placeholder': 'nível3',
  'customList.DataMessage':
    'Dados baseados nos dados mais recentes disponíveis para cada trecho.',
  'customList.removeFromProject': 'Remover deste projeto',
  'customList.removeFromProjectConfirmationTitle': 'Remover do projeto',
  'customList.removeFromProjectConfirmationMessage':
    'Tem certeza de que deseja remover {count} spans deste projeto?',
  'customList.removeFromProjectConfirmationButton': 'Remover spans',
  'customList.removeFilteredFromListSuccess':
    '{count} vãos removidos do projeto {projectName}',
  'customList.removeFilteredFromListError':
    'Erro ao remover do projeto. Tente novamente.',
  'customList.overviewZeroStateTitle': 'Crie o seu primeiro projeto',
  'action.cancel': 'Cancelar',
  'action.close': 'Fechar',
  'action.confirm': 'Confirmar',
  'action.delete': 'Excluir',
  'action.save': 'Salvar',
  'action.reset': 'Redefinir',
  'action.settings': 'Configurações',
  'action.editNameDescription': 'Editar nome e descrição',
  'action.programSettings': 'Configurações do programa',
  'action.archiveScenario': 'Arquivar este cenário',
  'action.archiveScenarioConfirmTitle': 'Arquivar este cenário?',
  'action.archiveScenarioConfirmMessage':
    'Este cenário será arquivado e não poderá ser editado.',
  'action.archive': 'Arquivar',
  'action.unarchiveScenario': 'Desarquivar este cenário',
  'action.keepActiveScenario': 'Manter plano ativo',
  'action.deleteScenario': 'Eliminar cenário',
  'action.deleteScenarioConfirmTitle':
    "Eliminar permanentemente ''{scenarioName}''?",
  'action.deleteScenarioConfirmMessage':
    'Este cenário é visível para toda a sua equipa. Se precisar dele mais tarde, considere arquivá-lo.',
  'action.deleteArchivedScenarioConfirmMessage':
    'Isso excluirá permanentemente o cenário para toda a sua equipe. Essa ação não pode ser desfeita.',
  'action.archiveInstead': 'Arquivar',
  'action.archiveScenarioModalTitle': "Arquivar ''{scenarioName}''?",
  'action.archiveScenarioModalMessage':
    'Este cenário deixará de ser editável. Pode restaurá-lo a qualquer momento.',
  'action.unarchiveScenarioConfirmTitle': 'Desarquivar este cenário?',
  'action.unarchiveScenarioConfirmMessage':
    'Este cenário voltará ao estado de rascunho e poderá ser editado novamente.',
  'action.unarchive': 'Desarquivar',
  'action.success': 'Sucesso',
  'action.loading': 'Carregando...',
  'action.error': 'Erro',
  'action.next': 'Próximo',
  'action.back': 'Voltar',
  'action.map': 'Mapa',
  'action.list': 'Lista',
  'action.summary': 'Resumo',
  'analysisList.tab.summary': 'Resumo',
  'analysisList.tab.spans': 'Linha',
  'action.create': 'Criar',
  'action.copyLink': 'Copiar link',
  'action.learnMore': 'Saber mais',
  'action.readMore': 'Leia mais',
  'action.copyLinkSuccess': 'Link copiado para a área de transferência',
  'action.deleteSuccessMessage': '{item} excluído com sucesso',
  'action.notFound': 'O recurso solicitado não foi encontrado.',
  'action.genericError':
    'Tente novamente ou entre em contato com seu ponto de contato Overstory.',
  'action.staleConflict':
    'Isto foi atualizado noutro local desde que o abriu. Recarregue a página e tente novamente.',
  'action.edit': 'Editar',
  'action.editError': 'Não foi possível salvar as edições',
  'action.ok': 'OK',
  'action.discard': 'Descartar',
  'action.createScenario': 'Criar cenário',
  'scenarioCard.openScenario': 'Abrir cenário',
  'scenarios.listHeader': 'Cenários',
  'scenarioMap.legend.title': 'Próximo ano de trabalho',
  'scenarioMap.legend.groupsByYear': '{groups} de {year}',
  'scenarioMap.legend.otherGroups': 'Outros {groups}',
  'action.exitEditMode': 'Sair do modo de edição',
  'action.saving': 'A guardar...',
  'action.saveChanges': 'Guardar alterações',
  'action.savingChanges': 'A guardar alterações...',
  'action.saved': 'Guardado',
  'action.export': 'Exportar {thing}',
  'action.exportGeneral': 'Exportar',
  'action.importGeneral': 'Importar',
  'action.select': 'Selecionar',
  'action.unsavedChanges': 'Alterações não salvas',
  'action.unsavedChangesMessage':
    'Você começou a editar. Tem certeza de que deseja sair desta página?',
  'action.actions': 'Ações',
  'action.clear': 'Clara',
  'action.publish': 'Publicar',
  'action.publishRelease': 'Publicar versão',
  'action.publishReleaseIntro': 'Escolha como pretende publicar esta versão:',
  'action.publishReleaseLoadFailed':
    'Não foi possível carregar as versões publicadas deste scan. Tente novamente.',
  'action.publishReleaseNoPublishedIntro':
    'De momento não há nenhuma versão publicada para este scan.',
  'action.publishReleaseNoPublishedInfo':
    'Depois de publicada, aparecerá na lista de versões que os clientes usam para ver os dados deste scan.',
  'action.publishReleaseReplaceOption': 'Substituir versão existente',
  'action.publishReleaseReplaceTooltip':
    'Se pretende melhorar uma versão existente a que o cliente já tem acesso, substituindo os resultados.',
  'action.releaseToReplaceLabel': 'Escolha a versão a substituir',
  'action.publishReleaseReplaceWarning':
    'Está prestes a substituir uma versão existente.',
  'action.publishReleaseReplaceWarningDetail':
    'O cliente deixará de conseguir ver o estado atualmente publicado.',
  'action.publishReleaseAddOption': 'Adicionar como nova versão',
  'action.publishReleaseAddTooltip':
    'Se pretende que o cliente possa escolher entre o que está publicado e esta nova versão. Por exemplo, se o cliente está a planear trabalho com uma versão existente e não deve perder o acesso ao que está publicado.',
  'action.publishReleaseAddWarning': 'Está prestes a adicionar uma versão.',
  'action.publishReleaseAddWarningDetail':
    'O cliente poderá escolhê-la juntamente com as outras versões existentes na lista de versões do produto.',
  'action.publishReleaseNamePreview':
    'A nova versão será publicada como "{name}".',
  'action.publishReleaseNamePreviewInherited':
    'A nova versão será publicada como "{name}", herdado da versão substituída.',
  'action.publishReleaseNamePreviewNoName':
    'A nova versão será publicada com o nome predefinido.',
  'action.customerFacingNameLabel': 'Nome visível para o cliente (opcional)',
  'action.customerFacingNamePlaceholder':
    'Escreva aqui o nome da versão visível para o cliente...',
  'action.releaseNameLabel': 'Nome da versão (opcional)',
  'action.releaseNamePlaceholder': 'ex.: 2026 — mar',
  'action.renameRelease': 'Renomear versão {name}',
  'action.releaseRenameSucceeded': 'O nome da versão foi atualizado.',
  'action.releaseNameTooLong':
    'O nome da versão não pode ter mais de {max} caracteres.',
  'action.revokeRelease': 'Revogar versão {name}',
  'action.revokeReleaseWarning':
    'Está prestes a revogar esta versão. O cliente deixará de poder vê-la. Esta ação não pode ser anulada.',
  'action.revoke': 'Revogar',
  'action.archiveRelease': 'Arquivar versão {name}',
  'action.archiveReleaseWarning':
    'Está prestes a arquivar este rascunho. Não será publicado nem ficará visível para o cliente. Esta ação não pode ser anulada.',
  'action.releasePublishSucceeded': 'A versão está agora publicada.',
  'action.releasePublishReplaceSucceeded':
    'A versão está agora publicada e a versão substituída revogada.',
  'action.releasePublishConflict':
    'Uma versão foi atualizada noutro sítio — atualize e tente novamente.',
  'action.releaseRevokeSucceeded': 'A versão está agora revogada.',
  'action.releaseArchiveSucceeded': 'A versão está agora arquivada.',
  'action.releasesArchiveSucceeded': '{count} versões arquivadas.',
  'action.releasesAllAlreadyArchived':
    'Estas versões já estavam arquivadas — nenhuma alteração necessária.',
  'action.releasesArchivePartlyAlready':
    '{count} versões arquivadas. {alreadyCount} já estavam arquivadas.',
  'action.bulkRevokeStaleDraft':
    'Uma versão selecionada já não é um rascunho — atualize e tente novamente.',
  'action.bulkArchiveReleases': 'Arquivar {count} versões',
  'action.bulkArchiveReleasesWarning':
    'Está prestes a arquivar estes rascunhos. Não serão publicados nem ficarão visíveis para o cliente. Esta ação não pode ser anulada.',
  'release.selectedCount': '{count} selecionadas',
  'release.selectAllDrafts': 'Selecionar todos os rascunhos',
  'release.deliveryFilterLabel': 'Entrega',
  'release.deliveryFilterPlaceholder': 'Introduza um identificador de entrega',
  'action.clearSelection': 'Limpar',
  'action.releaseStatusFailed': 'Algo correu mal. Tente novamente.',
  'action.unpublish': 'Despublicar',
  'action.defaultErrorMessage':
    'Por favor, atualize a página e tente novamente, ou entre em contato com seu representante de cliente Overstory se ainda estiver tendo problemas.',
  'noun.spans': 'trechos',

  'noun.span': 'trecho',
  'meta.lastEditedDate': 'Última edição {date}',
  'noun.project': 'projeto',
  'noun.miles': 'milhas',
  'noun.mile': 'milha',

  'noun.kilometers': 'quilômetros',
  'noun.kilometer': 'quilômetro',
  'noun.mile.short': 'milha',
  'noun.miles.short': 'milhas',
  'noun.kilometer.short': 'km',
  'noun.kilometers.short': 'kms',
  'noun.network': 'Rede',
  'programTable.headlineStatistic.riskTitle': 'Risco no escopo',
  'programTable.headlineStatistic.riskTooltip':
    'Representa a parcela esperada de SAIFI da rede digitalizada proveniente de invasão de vegetação que está no âmbito deste plano.',
  'programTable.headlineStatistic.wildfireRiskProgramTooltip':
    'Risco que se encontra no âmbito da área abrangida pelo programa, que pode não corresponder à redução de risco após a conclusão dos trabalhos. O risco de incêndio é calculado multiplicando o indicador de probabilidade (inflamabilidade por ano) pelo indicador de consequência (valor num raio de 0,07 milhas). <link>Saiba mais</link>',
  'programTable.headlineStatistic.wildfireRiskScenarioTooltip':
    'Risco que se encontra no âmbito da área abrangida pelo cenário, que pode não corresponder à redução de risco após a conclusão dos trabalhos. O risco de incêndio é calculado multiplicando o indicador de probabilidade (inflamabilidade por ano) pelo indicador de consequência (valor num raio de 0,07 milhas). <link>Saiba mais</link>',
  'programTable.wildfireRiskCalculation':
    'O risco de incêndio é calculado multiplicando o indicador de probabilidade (inflamabilidade por ano) pelo indicador de consequência (valor num raio de 0,07 milhas).',
  'programTable.headlineStatistic.riskExplanation':
    'de SAIFI vegetação esperado',
  'programTable.headlineStatistic.distanceTitle': '{distanceUnit} abordado',
  'programTable.headlineStatistic.distanceExplanation':
    'do total de {distanceUnit}',
  'programTable.headlineStatistic.workloadTitle': 'Carga de trabalho',
  'programTable.headlineStatistic.yearSelectorLabelSuffix': 'plano',
  'programTable.headlineStatistic.workloadExplanation':
    '{distanceUnit} de escopo ({formattedQty} total)',
  'programTable.headlineStatistic.encroachmentRatingSuffix': 'Invasão',
  'programTable.allGroups': 'Todos os {groupLabel} planejados',
  'programTable.allGroupsShort': 'Todos',
  'programTable.year.unknown': 'Desconhecido',
  'programTable.year.selectYear': 'Selecionar ano',
  'programTable.year.notPlanned': 'Não planejado',
  'programTable.columnGroup.dataMessage':
    'Métricas baseadas nos dados disponíveis mais recentes para cada extensão.',
  'programTable.columnGroup.plan': 'Plano',
  'planSelector.plans': '{num, plural, one {# cenário} other {# cenários}}',
  'planSelector.active': 'Ativo',
  'planStatusBadge.active': 'Ativo',
  'planStatusBadge.draft': 'Alternativo',
  'planStatusBadge.pre-draft': 'Alternativo',
  'planStatusBadge.archived': 'Arquivado',
  'planStatusBadge.tooltip.active':
    'Este é o cenário ativo, pronto para operacionalizar. Para editar o escopo, duplique ou mude para um alternativo.',
  'planStatusBadge.tooltip.draft':
    'Este é um cenário alternativo, ainda não pronto para operacionalizar. As alterações não afetarão o programa até serem publicadas.',
  'planStatusBadge.tooltip.pre-draft':
    'Este é um cenário do seu programa - não é o seu plano ativo. As alterações aqui não afetarão o programa atual até serem publicadas.',
  'planStatusBadge.tooltip.archived':
    'Este cenário foi arquivado e é somente leitura. Para reutilizá-lo, desarquive-o primeiro.',
  'releaseStatusBadge.draft': 'Rascunho',
  'releaseStatusBadge.revoked': 'Revogado',
  'releaseStatusBadge.archived': 'Arquivado',
  'releaseStatusBadge.published': 'Publicado',
  'releaseStatusBadge.combined': 'Combinado',
  'releaseSelector.latest': 'Mais recente',
  'planSelector.stat.reliabilityRisk': 'Risco de fiabilidade',
  'planSelector.stat.workload': 'Carga de trabalho',
  'planSelector.stat.estimatedCost': 'Custo estimado',
  'planSelector.duplicateScenario': 'Duplicar',
  'programTable.columnGroup.progress': 'Progresso',
  'programTable.columnGroup.risk': 'Risco',
  'programTable.columnGroup.risk.tooltip':
    'A pontuação de prioridade foi concebida para ajudá-lo a priorizar os circuitos com o maior número de spans P1 e P2, uma vez que impulsionam a maioria das interrupções.',
  'programTable.columnGroup.scenario': 'Escopo do cenário',
  'programTable.columnGroup.network': 'Rede',
  'programTable.columnGroup.planExploration': 'Planejar a exploração',
  'programTable.column.lastWorkYear': 'Último ano de trabalho',
  'programTable.column.nextWorkYear': 'Próximo ano de trabalho',
  'programTable.column.nextTrimDate': 'Próximo trabalho do ciclo',
  'programTable.column.expectedInterval.header': 'Intervalo esperado',
  'programTable.column.expectedInterval.yearLabel':
    '{years, plural, one {# ano} other {# anos}}',
  'programTable.column.targetStart': 'Início alvo',
  'programTable.column.workStarted': 'Trabalho iniciado',
  'programTable.column.workEnded': 'Trabalho concluído',
  'programTable.column.status': 'Estado',
  'programTable.column.notes': 'Notas',
  'programTable.column.view': 'Visualizar',
  'programTable.column.priority': 'Prioridade de confiabilidade',
  'programTable.column.reliabilityPriority': 'Prioridade de confiabilidade',
  'programTable.column.reliabilityRisk': 'Risco de confiabilidade',
  'programTable.column.wildfireRisk': 'Risco de incêndio florestal',
  'programTable.column.contractor': 'Empreiteiro',
  'programTable.column.spanCount': 'Contagem de vão',
  'programTable.column.workload': 'Carga de trabalho',
  'programTable.column.totalDistance': 'Total de {distanceUnit}',
  'programTable.column.totalDistance.filterLabel':
    'Filtrar por total de {distanceUnit}',
  'programTable.column.unitName': 'Nome da Unidade',
  'programTable.targetedDistance.header': 'Extensões direcionadas',
  'programTable.targetedDistance.bar.tooltip.enc_rating_5.header':
    'Invasão Alta',
  'programTable.targetedDistance.bar.tooltip.enc_rating_4.header':
    'Invasão Média',
  'programTable.targetedDistance.bar.tooltip.enc_rating_3.header':
    'Invasão Baixa',
  'programTable.targetedDistance.bar.tooltip.enc_rating_2.header':
    'Invasão Menor',
  'programTable.targetedDistance.bar.tooltip.enc_rating_1.header':
    'Sem Invasão',
  'programTable.targetedDistance.bar.tooltip.enc_rating_0.header':
    'Invasão Desconhecida',
  'programTable.targetedDistance.tooltip':
    '{distanceUnit} alvo e classificações de risco enc. desses trechos',
  'programTable.saveError':
    'Houve um erro ao salvar suas atualizações do Cronograma de Ciclos - entre em contato com seu representante de cliente Overstory se ainda estiver tendo problemas.',
  'programTable.scopeFilter.targetSpans': 'Vãos alvo',
  'programTable.scopeFilter.description':
    'Filtre a rede para definir o escopo do seu programa',
  'programTable.scopeFilter.emptyTitle': 'Nenhum filtro foi aplicado',
  'programTable.scopeFilter.emptyDescription':
    'Adicione regras para definir quais vãos devem ser incluídos no escopo',
  'programTable.scopeFilter.emptyDescriptionReadOnly':
    'Este é um modo somente leitura. Para alterar os seus vãos alvo, edite este cenário',
  'programTable.scopeFilter.addCondition': 'Adicionar condição',
  'programTable.scopeFilter.footerSpans': '{count} vãos',
  'programTable.scopeFilter.targetSpansWhere': 'Vãos alvo onde:',
  'programTable.scopeFilter.addGroup': 'Adicionar grupo',
  'programTable.scopeFilter.ungroup': 'Desagrupar',
  'programTable.scopeFilter.fieldPlaceholder': 'Nome da variável',
  'programTable.scopeFilter.operatorPlaceholder': 'Selecionar',
  'programTable.scopeFilter.valuePlaceholder': 'Selecionar',
  'programTable.scopeFilter.searchFields': 'Pesquisar campos',
  'programTable.scopeFilter.valueRequired':
    'Selecione um valor para concluir este filtro',
  'programTable.scopeFilter.addDisabledTooltip':
    'Conclua o filtro atual antes de adicionar outro',
  'programTable.scopeFilter.conjunction.and': 'E',
  'programTable.scopeFilter.conjunction.or': 'OU',
  'programTable.scopeFilter.category.reliability': 'Risco de fiabilidade',
  'programTable.scopeFilter.category.wildfire': 'Incêndio',
  'programTable.scopeFilter.category.assets': 'Ativos',
  'programTable.scopeFilter.category.encroachment': 'Invasão',
  'programTable.scopeFilter.category.fallIn': 'Queda',
  'programTable.scopeFilter.category.work': 'Trabalho',
  'programTable.scopeFilter.operator.isAnyOf': 'é qualquer um de',
  'programTable.scopeFilter.operator.isNoneOf': 'não é nenhum de',
  'programTable.scopeFilter.operator.isTrue': 'é verdadeiro',
  'programTable.scopeFilter.operator.isFalse': 'é falso',
  'programTable.scopeFilter.operator.gte': 'é ≥',
  'programTable.scopeFilter.operator.lte': 'é ≤',
  'programTable.scopeFilter.field.network': 'Rede',
  'programTable.scopeFilter.field.phasingType': 'Sistema de fases',
  'programTable.scopeFilter.field.voltageInKv': 'Tensão',
  'programTable.scopeFilter.field.priorityRatings': 'Prioridade de fiabilidade',
  'programTable.scopeFilter.field.wildfireRatings': 'Zona de incêndio',
  'programTable.scopeFilter.field.wildfirePriorityRatings':
    'Prioridade de incêndio',
  'programTable.scopeFilter.field.encroachmentRating': 'Nível de invasão',
  'programTable.scopeFilter.field.hasOverhang': 'Tem saliência',
  'programTable.scopeFilter.field.criticalTrees': 'Número de árvores críticas',
  'programTable.scopeFilter.field.decliningTrees':
    'Número de árvores em declínio',
  'programTable.scopeFilter.field.hazardTrees': 'Número de árvores perigosas',
  'programTable.scopeFilter.field.strikeTrees': 'Número de árvores de contacto',
  'programTable.scopeFilter.field.species': 'Espécie mais comum',
  'programTable.scopeFilter.field.workStatus': 'Estado do trabalho',
  'programTable.scopeFilter.field.fuelHazardRating': 'Perigo de combustível',
  'programTable.scopeFilter.field.fuelDistributionGrass': 'Combustível: grama',
  'programTable.scopeFilter.field.fuelDistributionShrub':
    'Combustível: arbusto',
  'programTable.scopeFilter.field.fuelDistributionTimberLitter':
    'Combustível: serrapilheira',
  'programTable.scopeFilter.field.fuelDistributionSlashBlowdown':
    'Combustível: resíduos verdes',
  'programTable.scopeFilter.field.fuelDistributionNonBurnable':
    'Combustível: não combustível',
  'programTable.columnVisibility.title': 'Mostrar/ocultar colunas',

  'programTable.estimatedCost.header': 'Custo estimado',
  'programTable.estimatedCost.modal.title': 'Estimativas de custo',
  'programTable.headlineStatistic.estimatedCostTitle': 'Custo estimado',
  'programTable.estimatedCost.modal.basisLabel':
    'Estimativa baseada no risco de invasão por',
  'programTable.estimatedCost.modal.encroachmentLevel.subtitle':
    'Custo estimado para trabalhar um...',

  'programTable.estimatedCost.modal.suffix.perItem': 'por {item}',
  'programTable.estimatedCost.field.encroachmentRiskSpan':
    'Vão com {level} risco de invasão',
  'programTable.estimatedCost.tooltip':
    'O custo estimado é baseado em suposições de custo unitário.',
  'programTable.estimatedCost.tooltip.settingsLink':
    'Ver em <link>Configurações do programa</link>.',
  'programTable.estimatedCost.saveSuccess': 'Configuração de custo salva',
  'programTable.estimatedCost.saveSuccessMessage':
    'Suas configurações de estimativa de custo foram atualizadas.',
  'programTable.overview.reliabilityRisk': 'Risco de fiabilidade',

  //Program settings
  'program.settings.modal.title': 'Configurações do programa',
  'program.settings.modal.tab.general': 'em geral',
  'program.settings.modal.tab.costsAssumptions': 'Suposições de custo',
  'program.settings.details': 'Detalhes do programa',
  'program.settings.field.name': 'Nome do programa',
  'program.settings.field.name.placeholder': 'Nome do programa',
  'program.settings.field.description': 'Descrição',
  'program.settings.field.description.placeholder':
    'Capture objetivos de alto nível ou KPIs para clarificar a intenção deste programa.',
  'program.settings.error.nameRequired':
    'O nome do programa não pode estar vazio',
  'program.settings.error.costRequired': 'O custo não pode estar vazio',
  'program.settings.saveSuccessMessage': 'As suas definições foram atualizadas',
  'program.settings.modal.tab.deleteProgram': 'Excluir programa',
  'program.settings.confirmDeletion': 'Confirmar exclusão',
  'program.settings.deleteProgramDescription':
    'Exclua permanentemente este programa e todos os cenários associados para sua equipe.',
  'program.settings.deleteProgramConfirmMessage':
    'A exclusão deste programa removerá permanentemente:',
  'program.settings.deleteProgramConfirmMessageEmpty':
    'Isso excluirá permanentemente o programa para toda a sua equipe.',
  'program.settings.deleteProgramConfirmBulletScenarios':
    '{count, plural, one {1 cenário} other {{count} cenários}}',
  'program.settings.deleteProgramConfirmBulletActiveScenario':
    '1 cenário ativo',
  'program.settings.deleteProgramConfirmBulletAlternateScenarios':
    '{count, plural, one {1 cenário alternativo} other {{count} cenários alternativos}}',
  'program.settings.deleteProgram': 'Excluir programa',
  'program.settings.deleteProgramSuccess': 'Programa excluído com sucesso',

  // All programs
  'program.overview.title': 'Todos os programas',
  'program.breadcrumb.allPrograms': 'Todos os programas',
  'program.breadcrumb.backToAllPrograms': 'Voltar a todos os programas',
  'program.create': 'Criar programa',
  'program.creation.wizard.title': 'Etapa {step} de {total} - Criar programa',
  'program.creation.wizard.titleScenario':
    'Etapa {step} de {total} - Criar cenário',
  'scenario.create.modalTitle': 'Criar cenário',
  'scenario.create.populationMethod.title':
    'Como quer preencher o próximo ano de trabalho para este cenário?',
  'scenario.create.populationMethod.fromCsv': 'Carregar a partir de CSV',
  'scenario.create.populationMethod.fromCsvDescription':
    "Importar 'próximo ano de trabalho' por grupo de planeamento a partir de uma folha de cálculo. Ideal para programas grandes.",
  'scenario.create.populationMethod.fromProduct': 'Selecionar no produto',
  'scenario.create.populationMethod.fromProductDescription':
    "Atribuir manualmente 'próximo ano de trabalho' por circuito usando a tabela do cenário.",
  'scenario.create.csv.title': 'Carregar CSV',
  'scenario.create.csv.subtitle':
    "Cria um cenário com os campos de 'próximo ano de trabalho' pré-preenchidos a partir do seu ficheiro.",
  'scenario.create.csv.fileRejected':
    'Ficheiro não suportado. Carregue um ficheiro CSV.',
  'scenario.create.csv.fileTooLarge':
    'O ficheiro é demasiado grande. Tamanho máximo: 10 MB.',
  'scenario.create.csv.dropzoneIdle': 'Arraste e largue o CSV aqui',
  'scenario.create.csv.browseFiles': 'Procurar ficheiros',
  'scenario.create.csv.replaceFile': 'Substituir ficheiro',
  'scenario.create.csv.errorTitle': 'Corrija os erros e volte a carregar o CSV',
  'scenario.create.csv.removeFile': 'Remover ficheiro',
  'scenario.create.csv.requirementsTitle': 'Requisitos do CSV:',
  'scenario.create.csv.req1Title':
    'Carregue um CSV com 2 colunas que correspondam aos nomes:',
  'scenario.create.csv.req1Col1': 'Coluna 1: planning_group',
  'scenario.create.csv.req1Col2': 'Coluna 2: next_trim_year',
  'scenario.create.csv.req2':
    'Todos os campos planning_group no CSV devem corresponder exatamente aos nomes dos grupos de planeamento da Overstory',
  'scenario.create.csv.req3': 'Os campos em falta ficarão em branco no cenário',
  'program.overview.statsByGroup': '{year} {groupLabel}',
  'program.overview.stats.reliabilityRisk': 'Risco de fiabilidade',
  'program.overview.stats.workload': 'Carga de trabalho',
  'program.overview.stats.estimatedCost': 'Custo estimado',
  'program.overview.stats.wildfireRisk': 'Risco de incêndio florestal',
  'program.overview.stats.perYear': '/ano',
  'program.overview.stats.wildfireRisk.secondaryValue':
    '{pct}% do risco da rede',
  'exploration.yearSwitcher.suffix': 'âmbito',
  'exploration.yearSwitcher.allYears': 'Todos os anos planejados',
  'exploration.yearSwitcher.metricsFor': 'Métricas para',

  // Plans
  'plan.createNewPlan': 'Criar novo cenário',
  'plan.copyOfName': 'Cópia de {name}',
  'plan.newScenarioDefaultName': 'Cenário sem título',
  'plan.editNameAndDescription': 'Editar nome e descrição',
  'plan.draftEdit.header.title': "Edição ''{planTitle}''",
  'plan.draft.modal.title': 'Configurações do plano',
  'scenario.settings.modal.title': 'Configurações do plano',
  'plan.draft.modal.description': 'Salve suas alterações atuais como rascunho',
  'plan.draft.modal.field.name': 'Nome do plano',
  'plan.draft.modal.field.name.placeholder':
    'Exemplo: abordagem otimizada em termos de custos',
  'plan.draft.modal.field.description': 'Descrição do plano',
  'plan.draft.modal.field.description.placeholder':
    'Por exemplo, explorar o que acontece se priorizarmos os circuitos com maior impacto no SAIDI, mantendo o orçamento abaixo de US$ 1,5 milhão...',
  'plan.draft.modal.field.helpText':
    'Este rascunho ficará visível para qualquer pessoa com acesso ao {programName}.',
  'plan.draft.banner.title': 'Plano preliminar',
  'plan.draft.banner.description':
    'Este é um plano preliminar, não o programa em vigor. As alterações aqui apresentadas não afetarão o programa atual até sua publicação.',
  'scenario.settings.name.error.nameRequired':
    'O nome do plano não pode estar vazio.',
  'plan.publish.modal.title': 'Publicar como o cenário ativo',
  'plan.publish.modal.title.active': 'Publicar cenário como o cenário ativo',
  'plan.publish': 'Publicar',
  'plan.publish.successMessage': 'O cenário foi publicado com sucesso.',
  'plan.unpublish.successMessage': 'O cenário foi despublicado com sucesso.',
  'plan.archive.successMessage': 'O cenário foi arquivado com sucesso',
  'plan.unarchive.successMessage': 'O cenário foi desarquivado com sucesso',
  'plan.notFound': 'Este cenário não foi encontrado.',
  'plan.unpublish.modal.title': "Despublicar ''{planName}''?",
  'plan.unpublish.modal.heading':
    "O seu programa ''{programName}'' deixará de ter um cenário ativo.",
  'plan.unpublish.modal.point1':
    'O seu programa deixará de ter uma fonte de verdade ativa.',
  'plan.unpublish.modal.point2':
    "Ainda poderá aceder a ''{planName}'' como um cenário no seu programa.",
  'plan.unpublish.modal.point3':
    'Pode republicar o seu cenário a qualquer momento.',
  'plan.publish.modal.heading':
    "''{planName}'' se tornará o cenário ativo para ''{programName}''. Isso o marcará como pronto para operacionalizar.",
  'plan.publish.modal.heading.active':
    "''{planName}'' substituirá o cenário ativo atual de ''{programName}'' e o marcará como pronto para operacionalizar.",
  'plan.editScenario': 'Editar',
  'plan.editDisabledTooltip.onlyActive':
    'O cenário ativo está pronto para ser operacionalizado e não pode ser editado. Para editar o escopo, duplique este cenário.',
  'plan.editDisabledTooltip.withAlternates':
    'O cenário ativo está pronto para ser operacionalizado e não pode ser editado. Para editar o escopo, duplique ou mude para um alternativo.',
  'plan.headlineStatistic.workloadExplanation': 'de escopo',
  'plan.headlineStatistic.workloadOfNetwork': '{pct}% da rede',

  // All plans
  'plan.active': 'Plano ativo',
  'plan.draft': 'Cenários alternativos',
  'plan.archived': 'Cenários arquivados',
  'plan.overview.empty': 'Nenhum plano disponível para este programa.',
  'plan.overview.empty.title': 'Modele cenários neste programa',
  'plan.overview.empty.description1':
    'Um cenário é um possível âmbito de trabalho para o seu programa, onde pode definir quais os tramos a trabalhar e em que ano.',
  'plan.overview.empty.description2':
    'Crie vários cenários para comparar o risco de fiabilidade, a carga de trabalho e o custo estimado lado a lado, e depois publique aquele que irá executar.',
  'plan.alternative': 'Planos alternativos',
  'program.overview.noActivePlan':
    'Publique um cenário para ver as métricas do programa',
  'program.reliabilityMetric.outages': 'interrupções',
  'program.reliabilityMetric.ci': 'CI',
  'program.reliabilityMetric.cmi': 'CMI',
  'program.reliabilityMetric.headline.outages': 'Interrupções',
  'program.reliabilityMetric.headline.ci': 'CI',
  'program.reliabilityMetric.headline.cmi': 'CMI',
  'program.reliabilityMetric.networkRiskPct': '{pct}% do risco da rede',
  'program.reliabilityMetric.networkSaifiPct': '{pct}% SAIFI da rede',
  'program.reliabilityMetric.label.relative': 'SAIFI da Rede',
  'program.reliabilityMetric.scannedNetworkSaifi': 'SAIFI da rede verificada',
  'program.reliabilityMetric.label.outages': 'Interrupções no escopo',
  'program.reliabilityMetric.label.ci': 'CI no escopo',
  'program.reliabilityMetric.label.cmi': 'CMI no escopo',
  'program.reliabilityMetric.tooltip':
    'O risco presente nos trechos incluídos neste cenário, no ano escolhido, pode não ser o mesmo que a redução do risco após a conclusão da obra. As métricas de risco de confiabilidade são baseadas no nível de interferência e no cronograma das linhas de distribuição.',
  'program.reliabilityMetric.networkTooltip':
    'O risco de confiabilidade para um determinado grupo de rede é baseado no nível de interferência e no escalonamento das linhas de distribuição.',
  'program.reliabilityMetric.programAbsoluteMetricsTooltip':
    'O risco presente nos trechos incluídos neste programa, no ano escolhido, pode não ser o mesmo que a redução do risco após a conclusão da obra. As métricas de risco de confiabilidade são baseadas no nível de interferência e no escalonamento das linhas de distribuição.',
  'program.overview.empty.title': 'Encontre os seus Programas aqui',
  'program.overview.empty.description':
    'Use Programas para armazenar todo o trabalho ativo de gestão de vegetação, desenhar diferentes cenários e ponderar os compromissos entre custos e risco mitigado.',
  'program.overview.empty.csmHelp':
    'Não sabe por onde começar? Contacte o seu Customer Success Manager para o ajudar a construir o seu primeiro programa.',
  'program.overview.empty.learnMore': 'Saiba mais no nosso artigo de ajuda.',

  // Red Flag Warnings
  'redFlagWarning.errorLoading': 'Erro ao carregar Avisos de Bandeira Vermelha',
  'redFlagWarning.title': 'Avisos de Bandeira Vermelha',
  'redFlagWarning.close': 'Fechar',
  'redFlagWarning.showAffectedSpans': 'Mostrar trechos afetados',
  'redFlagWarning.noWarningsTitle':
    'Nenhum Aviso de Bandeira Vermelha em ou perto de sua rede',
  'redFlagWarning.noWarningsBody':
    'Quando os Avisos de Bandeira Vermelha estão ativos, verifique os trechos afetados em toda a sua rede para ver rapidamente onde o risco de incêndio florestal está elevado. Sem mapas externos ou códigos necessários.',
  'programTable.yearChange.confirmTitle':
    'Tem certeza de que deseja fazer esta alteração?',
  'programTable.yearChange.confirmContent':
    '{fieldName} para {circuitName} alterado de {prevYear} para {newYear}',
  'programTable.yearChange.confirmButton': 'Confirmar alteração',

  'groupSummary.riskMetrics.title': 'Métricas de risco',
  'groupSummary.riskMetrics.riskPerYear': 'Risco / ano',
  'groupSummary.riskMetrics.burnabilityPerYear': 'Inflamabilidade / ano',
  'groupSummary.riskMetrics.valueWithinRadius': 'Valor num raio de 0,07 milhas',
  'groupSummary.riskMetrics.helpText':
    'O risco é calculado multiplicando a métrica de probabilidade (inflamabilidade por ano) pela consequência (valor num raio de 0,07 milhas).',
  'level3.fuelHazard.title': 'Perigo de combustível',
  'level3.fuelHazard.tooltip':
    'O perigo de combustível apresenta um nível de perigo relativo à sua rede (ex.: alto, médio, baixo) e uma pontuação absoluta numa escala até 1. O perigo de combustível baseia-se em imagens de vegetação com 30 cm de resolução e tem em conta a intensidade base do fogo, bem como a diversidade, adjacência e continuidade do combustível.',
  'groupSummary.fuelDistribution.title': 'Distribuição de combustível',
  'groupSummary.fuelDistribution.empty':
    'Sem dados de combustível disponíveis.',
  'level3.workType.title': 'Análise do tipo de trabalho',
  'level3.workType.byArea': 'Por área',
  'level3.workType.linearExtent': 'Extensão linear',
  'level3.workType.unit.sqft': '{value} pés²',
  'level3.workType.unit.sqm': '{value} m²',
  'workType.herbicide': 'Herbicida',
  'workType.mow': 'Roçada',
  'workType.cut': 'Corte',
  'workType.sideWall': 'Poda lateral',
  'workType.noWorkType': 'Sem tipo de trabalho',
  'fuelCategory.grass': 'Grama',
  'fuelCategory.shrub': 'Arbusto',
  'fuelCategory.timber_litter': 'Serrapilheira',
  'fuelCategory.slash_blowdown': 'Resíduos verdes',
  'fuelCategory.non_burnable': 'Não combustível',
  'filter.fuelDistribution.title': 'Distribuição de combustível',
  'filter.fuelDistribution.noConstraint': 'Sem restrição',
  'fuelDistribution.percentLessThan': 'Menos de {value}%',
  'filter.fuelHazardRating.title': 'Perigo de combustível',
  'filter.fuelHazardRating.allRatings': 'Todas as classificações',
  'reliabilityConfig.title': 'Configuração de dados de fiabilidade',
  'reliabilityConfig.section.sourceInfo': 'Informações da fonte',
  'reliabilityConfig.section.outageData': 'Dados de interrupções de vegetação',
  'reliabilityConfig.section.outageData.helper':
    'O total de interrupções de vegetação é calculado automaticamente a partir dos valores de invasão e queda de vegetação abaixo.',
  'reliabilityConfig.section.customerInterruption':
    'Dados de interrupção de clientes',
  'reliabilityConfig.section.customerInterruption.helper':
    'O total de minutos de interrupção de clientes (CMI) é calculado automaticamente a partir dos valores de invasão e queda de vegetação abaixo.',
  'reliabilityConfig.section.customerImpact': 'Impacto no cliente',
  'reliabilityConfig.section.customerImpact.helper':
    'As contagens de clientes são utilizadas para converter dados de interrupções em métricas de impacto ponderadas por cliente. Utilize os valores predefinidos da Overstory ou introduza manualmente as contagens médias de clientes por tipo de fase da sua rede.',
  'reliabilityConfig.field.primaryMetric': 'Métrica de fiabilidade predefinida',
  'reliabilityConfig.field.dataSourceName': 'Nome da fonte de dados',
  'reliabilityConfig.field.timePeriod': 'Período de tempo',
  'reliabilityConfig.field.overheadLineLength':
    'Total de {distanceUnit} de linha de distribuição aérea representados por estes dados',
  'reliabilityConfig.field.description': 'Descrição (opcional)',
  'reliabilityConfig.field.encRelatedOutages':
    'Contagem de interrupções por invasão de vegetação',
  'reliabilityConfig.field.fallinRelatedOutages':
    'Contagem de interrupções por queda de vegetação',
  'reliabilityConfig.field.totalOutages': 'Total de interrupções de vegetação',
  'reliabilityConfig.field.encRelatedCmi':
    'Minutos de interrupção de clientes por invasão de vegetação',
  'reliabilityConfig.field.fallinRelatedCmi':
    'Minutos de interrupção de clientes por queda de vegetação',
  'reliabilityConfig.field.totalCmi':
    'Total de minutos de interrupção de clientes',
  'reliabilityConfig.field.totalCiInstances':
    'Total de instâncias de interrupção de clientes (CI)',
  'reliabilityConfig.field.singlePhase':
    'Contagem média de clientes — monofásico',
  'reliabilityConfig.field.twoPhase': 'Contagem média de clientes — bifásico',
  'reliabilityConfig.field.threePhase':
    'Contagem média de clientes — trifásico',
  'reliabilityConfig.primaryMetric.absoluteOutages': 'Interrupções',
  'reliabilityConfig.primaryMetric.absoluteCi': 'CI',
  'reliabilityConfig.primaryMetric.absoluteCmi': 'CMI',
  'reliabilityConfig.placeholder.dataSourceName':
    'ex. interrupcoes-rede-2025-T1.csv',
  'reliabilityConfig.placeholder.timePeriod':
    'Selecionar um intervalo de datas',
  'reliabilityConfig.placeholder.overheadLines': 'Ex: 12.500',
  'reliabilityConfig.placeholder.description': 'adicionar descrição aqui',
  'reliabilityConfig.placeholder.encRelatedOutages': 'Ex: 32',
  'reliabilityConfig.placeholder.fallinRelatedOutages': 'Ex: 28',
  'reliabilityConfig.placeholder.encRelatedCmi': 'Ex: 18.420',
  'reliabilityConfig.placeholder.fallinRelatedCmi': 'Ex: 12.950',
  'reliabilityConfig.placeholder.ciInstances': 'Ex: 4.560',
  'reliabilityConfig.placeholder.singlePhase': 'Ex: 28',
  'reliabilityConfig.placeholder.twoPhase': 'Ex: 42',
  'reliabilityConfig.placeholder.threePhase': 'Ex: 65',
  'reliabilityConfig.customerImpact.useDefaults':
    'Usar números de impacto de cliente predefinidos da Overstory',
  'reliabilityConfig.customerImpact.useDefaults.hint':
    'Utiliza contagens médias de clientes por fase do setor.',
  'reliabilityConfig.customerImpact.manual':
    'Introduzir manualmente contagens médias de clientes por fase',
  'reliabilityConfig.customerImpact.manual.hint':
    'Utilize as contagens de clientes da sua rede para cada tipo de fase.',
  'reliabilityConfig.save.success':
    'Configuração de métricas de fiabilidade guardada.',
  'reliabilityConfig.save.error':
    'Falha ao guardar a configuração. Por favor, tente novamente.',
  'reliabilityConfig.cancelDialog.title': 'Cancelar alterações?',
  'reliabilityConfig.cancelDialog.message':
    'Todas as atualizações feitas na configuração serão perdidas.',
  'reliabilityConfig.emptyState': 'Selecione um cliente para começar.',
  'vegetationIntelligence.aboutTheData.acrossPrograms':
    'O trabalho conta em todos os programas. Se um vão foi concluído num programa, aparece como tratado mesmo quando outro programa também o inclui. Isto ajuda as equipas a não voltar a terreno trabalhado recentemente.',
  'vegetationIntelligence.aboutTheData.addressedIntro':
    'Um vão está <b>tratado</b> quando tem pelo menos um registo de trabalho <b>de 2025 ou 2026</b> que seja um dos seguintes, em qualquer programa.',
  'vegetationIntelligence.aboutTheData.addressedTitle':
    'O que significa “tratado”',
  'vegetationIntelligence.aboutTheData.after2026': '2027 e posterior',
  'vegetationIntelligence.aboutTheData.after2026Description':
    'O trabalho planeado só é mostrado até ao fim de 2026.',
  'vegetationIntelligence.aboutTheData.before2025': 'Antes de 2025',
  'vegetationIntelligence.aboutTheData.before2025Description':
    'Os registos mais antigos ficam nos dados como histórico, mas são considerados desatualizados e não tornam um vão tratado.',
  'vegetationIntelligence.aboutTheData.constructionRebuilds':
    '2025-2027 Construction Rebuilds',
  'vegetationIntelligence.aboutTheData.constructionRebuildsDescription':
    'Folha de cálculo da AEP TX. Âmbitos de reconstrução por zona de dispositivo de proteção (Resiliency Construction Rebuilds).',
  'vegetationIntelligence.aboutTheData.dailySyncBody':
    'Obtemos diariamente os registos e estados mais recentes do Fulcrum.',
  'vegetationIntelligence.aboutTheData.dailySyncTitle':
    'Os dados são sincronizados diariamente com o Fulcrum',
  'vegetationIntelligence.aboutTheData.excludedWork':
    'O trabalho cuja localização é desconhecida, os registos locais pequenos e o trabalho descrito apenas dentro de um circuito ou zona de dispositivo maior e incerta não são incluídos diretamente, embora essas áreas possam ainda estar tratadas por outros programas.',
  'vegetationIntelligence.aboutTheData.fulcrum': 'Fulcrum',
  'vegetationIntelligence.aboutTheData.fulcrumDescription':
    'O trabalho concluído conta como tratado, o trabalho marcado como necessário não conta.',
  'vegetationIntelligence.aboutTheData.goodToKnowTitle': 'Bom saber',
  'vegetationIntelligence.aboutTheData.noWorkNeeded': 'Sem trabalho necessário',
  'vegetationIntelligence.aboutTheData.noWorkNeededDescription':
    'Alguém avaliou o vão e não encontrou nada a fazer.',
  'vegetationIntelligence.aboutTheData.notCountedTitle': 'O que não conta',
  'vegetationIntelligence.aboutTheData.plannedWorkBody':
    'O trabalho com planos concretos para ser concluído até ao fim de 2026 é considerado “tratado”. Excetua-se o trabalho registado no Fulcrum (em 2026, sobretudo o WMP Overstory Project), que regista a conclusão real do trabalho.',
  'vegetationIntelligence.aboutTheData.plannedWorkTitle':
    'O trabalho planeado assume-se como feito',
  'vegetationIntelligence.aboutTheData.programsOverlapBody':
    'Um vão pode pertencer a mais de um programa, por isso a soma dos totais dos programas é maior do que o total geral.',
  'vegetationIntelligence.aboutTheData.programsOverlapTitle':
    'Os programas sobrepõem-se',
  'vegetationIntelligence.aboutTheData.resiliencyWorkPlan':
    'Resiliency Veg. Work Plan 2025_2027',
  'vegetationIntelligence.aboutTheData.resiliencyWorkPlanDescription':
    'Folha de cálculo da AEP TX. Trabalho de vegetação de resiliência planeado por circuito (Resiliency Vegetation).',
  'vegetationIntelligence.aboutTheData.runningList': 'Running List',
  'vegetationIntelligence.aboutTheData.runningListDescription':
    'Folha de cálculo da AEP TX. Perfect Power, pedidos de clientes e outro trabalho, mais evidência de trabalho Tier 1 e Tier 2 concluído.',
  'vegetationIntelligence.aboutTheData.sourcesTitle': 'De onde vêm os dados',
  'vegetationIntelligence.aboutTheData.tier1WorkPlans': 'Tier 1 Work Plans',
  'vegetationIntelligence.aboutTheData.tier1WorkPlansDescription':
    'Folha de cálculo da AEP TX. O plano de manutenção de 2026 (Reliability-driven Maintenance).',
  'vegetationIntelligence.aboutTheData.title': 'Sobre os dados',
  'vegetationIntelligence.aboutTheData.unaddressedIntro':
    'Um vão está <b>por tratar</b> quando não tem trabalho concluído, avaliado ou planeado <b>de 2025 ou 2026</b>.',
  'vegetationIntelligence.aboutTheData.unaddressedTitle':
    'O que significa “por tratar”',
  'vegetationIntelligence.aboutTheData.unclassifiedBody':
    'Alguns registos confirmam que o trabalho foi feito, mas não identificam as linhas específicas trabalhadas. Excluímos esse trabalho, e os trabalhos locais pequenos sem áreas mapeadas, das métricas operacionais e de impacto:',
  'vegetationIntelligence.aboutTheData.unclassifiedConstruction':
    '<b>Construction rebuilds:</b> os registos listam 68 milhas de projetos concluídos cujas localizações de trabalho de vegetação continuam incertas. As áreas mais amplas identificadas contêm 1366 milhas.',
  'vegetationIntelligence.aboutTheData.unclassifiedReliability':
    '<b>Reliability-driven Maintenance:</b> as equipas reportaram ter concluído 24 de 63 milhas planeadas em 12 circuitos, mas não conseguimos localizar as partes concluídas. Outro circuito tinha um plano de 5 milhas e é descrito como quase concluído, sem um valor de milhas concluídas.',
  'vegetationIntelligence.aboutTheData.unclassifiedRunningList':
    '<b>Running List:</b> os registos indicam 1048 milhas trabalhadas sem especificar localizações. Identificam apenas áreas mais amplas que contêm 15 133 milhas.',
  'vegetationIntelligence.aboutTheData.unclassifiedTitle':
    'Alguns dados não puderam ser interpretados e classificados',
  'vegetationIntelligence.aboutTheData.workCompleted': 'Trabalho concluído',
  'vegetationIntelligence.aboutTheData.workCompletedDescription':
    'O trabalho terminou',
  'vegetationIntelligence.aboutTheData.workLogs':
    'Registos de trabalho da Overstory',
  'vegetationIntelligence.aboutTheData.workLogsDescription':
    'Trabalho registado diretamente na aplicação Overstory.',
  'vegetationIntelligence.aboutTheData.workNeeded': 'Trabalho necessário',
  'vegetationIntelligence.aboutTheData.workNeededDescription':
    'Trabalho marcado como necessário. É uma recomendação, não um compromisso, por isso o vão fica por tratar até o trabalho ser planeado ou feito.',
  'vegetationIntelligence.aboutTheData.workPlanned': 'Trabalho planeado',
  'vegetationIntelligence.aboutTheData.workPlannedDescription':
    'A AEP TX planeou o trabalho para conclusão até ao fim de 2026, com base nos seus planos de trabalho.',
  'vegetationIntelligence.addressed': 'Tratado',
  'vegetationIntelligence.addressedShare': '{name} tratado',
  'vegetationIntelligence.addressedSpans': 'Linhas tratadas',
  'vegetationIntelligence.allCircuits': 'Todos os circuitos',
  'vegetationIntelligence.allDistricts': 'Todos os distritos',
  'vegetationIntelligence.circuitCount':
    '{count, plural, one {# circuito} other {# circuitos}}',
  'vegetationIntelligence.circuits': 'Circuitos',
  'vegetationIntelligence.districtCount':
    '{count, plural, one {# distrito} other {# distritos}}',
  'vegetationIntelligence.districts': 'Distritos',
  'vegetationIntelligence.lineMiles': 'Milhas de linha',
  'vegetationIntelligence.lineMilesByProgram':
    'Milhas de linha tratadas por programa',
  'vegetationIntelligence.navLabel': 'Vegetação',
  'vegetationIntelligence.network': 'Rede',
  'vegetationIntelligence.noProgram': 'Sem programa',
  'vegetationIntelligence.riskUnderManagement': 'Risco sob gestão',
  'vegetationIntelligence.sort': 'Ordenar',
  'vegetationIntelligence.sortMilesAddressed':
    'Ordenar: Milhas de linha tratadas',
  'vegetationIntelligence.sortMilesUnaddressed':
    'Ordenar: Milhas de linha por tratar',
  'vegetationIntelligence.spans': 'Linhas',
  'vegetationIntelligence.unaddressed': 'Por tratar',
  'vegetationIntelligence.unaddressedRisk': 'Risco não tratado',
};

export default pt_PT;
